export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-information-line"></i>
            关于我们
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6">
            关于嫩草视频
          </h2>
          <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4 text-left bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <p>
              嫩草视频是一个专注于影视资源聚合与导航的在线平台，致力于为广大追剧爱好者提供一站式的观影入口。
              我们聚合了妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频等主流影视平台的优质内容，
              涵盖悬疑探案、都市情感、古装传奇、科幻奇幻等多种题材，最新电视剧完整版高清在线观看，电影大全每日更新。
            </p>
            <p>
              平台以「追剧不等待」为核心使命，通过全天候内容监测与快速更新机制，确保用户第一时间获取全网热播新剧资源。
              无需下载多个 App，无需反复切换平台，一个页面即可畅享全网精彩影视内容。
            </p>
            <p>
              嫩草视频始终坚持为用户提供纯净、高效的观影导航体验。本站内容仅供学习交流，
              请用户支持正版影视作品，在有条件的平台观看正版内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}